'use strict';

exports.array = require('./array');
exports.matrix = require('./matrix');



/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-gsd/~/ml-stat/index.js
 ** module id = 32
 ** module chunks = 0
 **/